import { HttpContextToken } from '@angular/common/http';
import { IHttpContext } from '../model';

export const HTTP_CONTEXT = new HttpContextToken<IHttpContext>(() => ({
  loader: { toggle: undefined },
  mock: { args: undefined },
  resolvers: { severities: undefined }
}));
